"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var AdminApi = /** @class */ (function () {
    function AdminApi(axiosInstance) {
        var _this = this;
        this.createRandomResponsesForSchool = function (schoolId, date, maxNumberOfResponses) {
            if (date === void 0) { date = new Date(); }
            _this.instance.post("/api/demo/school/" + schoolId + "/create-responses", {
                date: date,
                maxNumberOfResponses: maxNumberOfResponses,
            });
        };
        this.instance = axiosInstance || axios_1.default;
    }
    return AdminApi;
}());
exports.default = AdminApi;
